import React from "react";
import ChatSection from "pageComponents/chatSection/ChatSection";

export default function ChatPage()  {
    return (
        <div >
          <ChatSection/>
        </div>
      );
};